<template>
  <div
    :class="[
      'ra-bna',
      headerClasses,
      { 'ra-bna__custom-separator-icon': slides[activeLayout].separatorIcon },
    ]"
    :data-refapp-tagging-id="taggingId"
    :style="componentStylingVars"
    role="region"
  >
    <header class="ra-bna__header">
      <div class="ra-bna__textcontent">
        <component :is="titleHeadingLevel" v-if="!!title" class="ra-bna__heading">{{
          title
        }}</component>
        <component :is="subtitleElement" v-if="!!subtitle" class="ra-bna__subheading">{{
          subtitle
        }}</component>
        <div v-if="description" class="ra-bna__description" v-html="description"></div>
        <a
          v-if="shouldRenderCta"
          class="ra-bna__cta"
          :href="cta.url"
          :target="cta.target"
          data-refapp-tagging-target="refapp-beforeafter-cta"
        >
          {{ cta.label }}
        </a>
      </div>
      <refapp-beforeafter-thumbnails
        v-if="slides.length > 1"
        :active-index="activeLayout"
        @updateActiveLayout="setActiveLayout"
      />
    </header>

    <refapp-beforeafter-compare
      :id="`${taggingId}-comparison-${activeLayout}`"
      :data-refapp-tagging-target="`slider-${activeLayout}`"
      :before-image="activeBeforeImage"
      :after-image="activeAfterImage"
      :before-image-alt="activeBeforeImage?.altText"
      :after-image-alt="activeAfterImage?.altText"
    >
      <template #before><slot name="before"></slot></template>
      <template #before-caption><slot name="before-caption"></slot></template>
      <template #after><slot name="after"></slot></template>
      <template #after-caption><slot name="after-caption"></slot></template>
      <template #handle><slot name="handle"></slot></template>
      <template #extra><slot name="extra"></slot></template>
    </refapp-beforeafter-compare>
  </div>
</template>

<script>
import RefappBeforeafterCompare from './base/compare.vue';
import RefappBeforeafterThumbnails from './base/thumbnails.vue';

export default {
  name: 'refapp-beforeafter',
  components: {
    RefappBeforeafterCompare,
    RefappBeforeafterThumbnails,
  },
  inject: [
    'taggingId',
    'title',
    'titleHeadingLevel',
    'subtitle',
    'subtitleElement',
    'layout',
    'slides',
    'moduleBackgroundColor',
    'moduleCopyTextColor',
    'beforeAfterCaptionColor',
    'thumbnailNavLabelNext',
    'thumbnailNavLabelPrev',
    'thumbnailsWrapperLabel',
    'description',
    'cta',
  ],
  data() {
    return {
      activeLayout: 0,
    };
  },
  computed: {
    headerClasses() {
      const layout = 'ra-title--' + this.layout.position;
      const headingHorizontal = 'ra-title-text--' + this.layout.horizontalAlignment;
      const headingVertical = 'ra-title-text--' + this.layout.verticalAlignment;
      return [layout, headingHorizontal, headingVertical];
    },
    componentStylingVars() {
      const vars = {
        '--refapp-beforeafter-header-background-color': this.moduleBackgroundColor || '#fff',
        '--refapp-beforeafter-copy-text-color': this.moduleCopyTextColor || '#000',
        '--refapp-beforeafter-caption-color': this.beforeAfterCaptionColor || '#000',
      };

      if (this.slides[this.activeLayout].separatorIcon) {
        vars['--refapp-beforeafter-divider-control-icon'] =
          `url(${this.slides[this.activeLayout].separatorIcon})`;
      }
      return vars;
    },
    activeBeforeImage() {
      return this.slides[this.activeLayout].beforeImage;
    },
    activeAfterImage() {
      return this.slides[this.activeLayout].afterImage;
    },
    shouldRenderCta() {
      return !!this.cta.label && !!this.cta.url;
    },
  },
  methods: {
    setActiveLayout(index) {
      this.activeLayout = index;
    },
  },
};
</script>

<style lang="scss">
@use '../styles/entry';
</style>
